import * as React from "react";

export default (props: {
    checked: boolean,
    children?: any,
    disabled?: boolean,
    onChange: (checked: boolean) => void,
    style?: React.CSSProperties,
}) => {
    return <label
        className="CMS_checkbox CMS_checkbox_ml0"
        style={props.style}
    >
        <input
            type="checkbox"
            className="CMS_input"
            checked={props.checked}
            onChange={(e) => {
                if (props.disabled) {
                    return;
                }
                props.onChange(!props.checked);
            }}
        />
        <span className={props.disabled ? "disabled" : ""}>
            <em className="fa" aria-hidden="true"></em>
        </span>
        {props.children}
    </label>;
};
